(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nm-caffeine-calculator"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  // Typical milligrams for a standard serving. Every row stays editable
  // because real values swing hard by brew, bean and brand.
  var PRESETS = [
    { id: 'drip',      label: 'Brewed coffee (8 oz)',        mg: 95 },
    { id: 'espresso',  label: 'Espresso (1 shot)',           mg: 64 },
    { id: 'latte',     label: 'Latte or cappuccino (2 shots)', mg: 128 },
    { id: 'coldbrew',  label: 'Cold brew (12 oz)',           mg: 200 },
    { id: 'instant',   label: 'Instant coffee (8 oz)',       mg: 62 },
    { id: 'blacktea',  label: 'Black tea (8 oz)',            mg: 47 },
    { id: 'greentea',  label: 'Green tea (8 oz)',            mg: 28 },
    { id: 'matcha',    label: 'Matcha (1 tsp)',              mg: 70 },
    { id: 'energy',    label: 'Energy drink (8.4 oz)',       mg: 80 },
    { id: 'energyxl',  label: 'Large energy drink (16 oz)',  mg: 160 },
    { id: 'cola',      label: 'Cola (12 oz)',                mg: 34 },
    { id: 'preworkout',label: 'Pre-workout (1 scoop)',       mg: 200 },
    { id: 'decaf',     label: 'Decaf coffee (8 oz)',         mg: 2 },
    { id: 'custom',    label: 'Something else',              mg: 100 }
  ];

  // Anchoring the axis at 04:00 keeps a 12:30am bedtime sorted after an
  // 11pm coffee instead of wrapping around to the start of the day.
  var DAY_ANCHOR = 4;
  var HALF_LIFE = 5;
  var HALF_LIFE_FAST = 4;
  var HALF_LIFE_SLOW = 6;
  var AXIS_HOURS = 24;

  function parseTime(value) {
    if (!value) return null;
    var parts = String(value).split(':');
    if (parts.length < 2) return null;
    var h = parseInt(parts[0], 10);
    var m = parseInt(parts[1], 10);
    if (isNaN(h) || isNaN(m)) return null;
    return h + m / 60;
  }

  function toAxis(clockHours) {
    if (clockHours === null) return null;
    return (clockHours - DAY_ANCHOR + 24) % 24;
  }

  function axisToLabel(axisHours) {
    var clock = (axisHours + DAY_ANCHOR) % 24;
    var h = Math.floor(clock);
    var suffix = h < 12 ? 'am' : 'pm';
    var display = h % 12;
    if (display === 0) display = 12;
    return display + suffix;
  }

  // Total active caffeine at a point on the axis, for a given half-life.
  function totalAt(drinks, axisPoint, halfLife) {
    var sum = 0;
    for (var i = 0; i < drinks.length; i++) {
      var d = drinks[i];
      if (d.axis === null || !d.mg) continue;
      if (axisPoint < d.axis) continue;
      sum += d.mg * Math.pow(0.5, (axisPoint - d.axis) / halfLife);
    }
    return sum;
  }

  function equivalentPhrase(mg) {
    if (mg < 10) return 'That is effectively nothing. Your sleep is not paying for it.';
    var anchors = [
      { mg: 28, text: 'about a cup of green tea' },
      { mg: 47, text: 'about a cup of black tea' },
      { mg: 64, text: 'about a shot of espresso' },
      { mg: 95, text: 'about a full cup of brewed coffee' },
      { mg: 160, text: 'about a large energy drink' },
      { mg: 200, text: 'about a cold brew' }
    ];
    var best = anchors[0];
    var bestGap = Math.abs(mg - anchors[0].mg);
    for (var i = 1; i < anchors.length; i++) {
      var gap = Math.abs(mg - anchors[i].mg);
      if (gap < bestGap) { best = anchors[i]; bestGap = gap; }
    }
    return 'That is ' + best.text + ', still working, as you try to fall asleep.';
  }

  function svgEl(name, attrs) {
    var el = document.createElementNS('http://www.w3.org/2000/svg', name);
    for (var key in attrs) {
      if (Object.prototype.hasOwnProperty.call(attrs, key)) {
        el.setAttribute(key, attrs[key]);
      }
    }
    return el;
  }

  function buildChart(container, drinks, bedAxis, peak, summary, threshold) {
    container.textContent = '';

    var W = 720, H = 240, padL = 44, padR = 14, padT = 16, padB = 30;
    var plotW = W - padL - padR;
    var plotH = H - padT - padB;
    var yMax = Math.max(peak, 50) * 1.15;

    var svg = svgEl('svg', {
      viewBox: '0 0 ' + W + ' ' + H,
      role: 'img',
      'aria-label': summary
    });

    function x(axisPoint) { return padL + (axisPoint / AXIS_HOURS) * plotW; }
    function y(mg) { return padT + plotH - (mg / yMax) * plotH; }

    // Horizontal gridlines with milligram labels.
    var steps = 4;
    for (var g = 0; g <= steps; g++) {
      var val = (yMax / steps) * g;
      var gy = y(val);
      svg.appendChild(svgEl('line', {
        x1: padL, y1: gy, x2: W - padR, y2: gy,
        class: g === 0 ? 'nm-axis' : 'nm-grid'
      }));
      var lbl = svgEl('text', { x: padL - 8, y: gy + 4, 'text-anchor': 'end', class: 'nm-tick-text' });
      lbl.textContent = Math.round(val);
      svg.appendChild(lbl);
    }

    // Sample the two extreme half-lives to get the uncertainty band.
    var stepH = 0.25;
    var fast = [], slow = [], mid = [];
    for (var t = 0; t <= AXIS_HOURS + 0.001; t += stepH) {
      fast.push([x(t), y(totalAt(drinks, t, HALF_LIFE_FAST))]);
      slow.push([x(t), y(totalAt(drinks, t, HALF_LIFE_SLOW))]);
      mid.push([x(t), y(totalAt(drinks, t, HALF_LIFE))]);
    }

    function toPath(points, close) {
      var d = '';
      for (var i = 0; i < points.length; i++) {
        d += (i === 0 ? 'M' : 'L') + points[i][0].toFixed(1) + ' ' + points[i][1].toFixed(1);
      }
      if (close) {
        for (var j = close.length - 1; j >= 0; j--) {
          d += 'L' + close[j][0].toFixed(1) + ' ' + close[j][1].toFixed(1);
        }
        d += 'Z';
      }
      return d;
    }

    svg.appendChild(svgEl('path', { d: toPath(slow, fast), class: 'nm-band' }));
    svg.appendChild(svgEl('path', { d: toPath(mid), class: 'nm-line' }));

    // The research threshold, drawn on top of the curve so it reads as a
    // line the curve crosses rather than part of the data.
    if (threshold > 0 && threshold < yMax) {
      var ty = y(threshold);
      svg.appendChild(svgEl('line', {
        x1: padL, y1: ty, x2: W - padR, y2: ty, class: 'nm-threshold-line'
      }));
      var tlabel = svgEl('text', {
        x: padL + 6, y: ty - 5, 'text-anchor': 'start', class: 'nm-threshold-text'
      });
      tlabel.textContent = threshold + ' mg: affects sleep above here';
      svg.appendChild(tlabel);
    }

    // Hour ticks every four hours across the axis.
    for (var h = 0; h <= AXIS_HOURS; h += 4) {
      var tx = svgEl('text', {
        x: x(h), y: H - padB + 18, 'text-anchor': 'middle', class: 'nm-tick-text'
      });
      tx.textContent = axisToLabel(h);
      svg.appendChild(tx);
    }

    // Bedtime marker.
    if (bedAxis !== null) {
      var bx = x(bedAxis);
      svg.appendChild(svgEl('line', {
        x1: bx, y1: padT, x2: bx, y2: padT + plotH, class: 'nm-bed-line'
      }));
      var anchor = bedAxis > AXIS_HOURS * 0.85 ? 'end' : (bedAxis < AXIS_HOURS * 0.12 ? 'start' : 'middle');
      var bedLabel = svgEl('text', {
        x: bx, y: padT - 4, 'text-anchor': anchor, class: 'nm-bed-text'
      });
      bedLabel.textContent = 'BED';
      svg.appendChild(bedLabel);
    }

    container.appendChild(svg);
  }

  function readDrinks(section) {
    var rows = section.querySelectorAll('[data-drink-row]');
    var out = [];
    for (var i = 0; i < rows.length; i++) {
      var timeInput = rows[i].querySelector('[data-drink-time]');
      var mgInput = rows[i].querySelector('[data-drink-mg]');
      var mg = parseFloat(mgInput && mgInput.value);
      out.push({
        axis: toAxis(parseTime(timeInput && timeInput.value)),
        mg: isNaN(mg) ? 0 : Math.max(0, mg)
      });
    }
    return out;
  }

  function update(section) {
    var drinks = readDrinks(section);
    var bedAxis = toAxis(parseTime(section.querySelector('[data-bedtime]').value));

    var figure = section.querySelector('[data-figure]');
    var rangeEl = section.querySelector('[data-range]');
    var captionEl = section.querySelector('[data-caption]');
    var equivEl = section.querySelector('[data-equiv]');
    var chartEl = section.querySelector('[data-chart]');

    var atBed = bedAxis === null ? 0 : totalAt(drinks, bedAxis, HALF_LIFE);
    var atBedFast = bedAxis === null ? 0 : totalAt(drinks, bedAxis, HALF_LIFE_FAST);
    var atBedSlow = bedAxis === null ? 0 : totalAt(drinks, bedAxis, HALF_LIFE_SLOW);

    var rounded = Math.round(atBed);
    figure.textContent = '';
    figure.appendChild(document.createTextNode(String(rounded)));
    var unit = document.createElement('span');
    unit.className = 'nm-figure-unit';
    unit.textContent = 'MG';
    figure.appendChild(unit);

    rangeEl.textContent = 'Range across a 4 to 6 hour half-life: '
      + Math.round(atBedFast) + ' to ' + Math.round(atBedSlow) + ' mg';

    var totalConsumed = 0;
    for (var i = 0; i < drinks.length; i++) totalConsumed += drinks[i].mg;

    if (totalConsumed === 0) {
      captionEl.textContent = 'Add a drink above to run your numbers.';
      equivEl.textContent = '';
    } else {
      captionEl.textContent = 'You drank ' + Math.round(totalConsumed)
        + ' mg today. About ' + Math.round((atBed / totalConsumed) * 100)
        + '% of it is still active at bedtime.';
      equivEl.textContent = equivalentPhrase(atBed);
    }

    // Where the number lands against the published thresholds.
    var threshold = parseFloat(section.dataset.thresholdMg) || 30;
    var thresholdHigh = parseFloat(section.dataset.thresholdHighMg) || 175;

    var pill = section.querySelector('[data-verdict-pill]');
    var verdictText = section.querySelector('[data-verdict-text]');
    var verdict = section.querySelector('[data-verdict]');

    if (totalConsumed === 0) {
      section.removeAttribute('data-zone');
      verdict.hidden = true;
    } else {
      verdict.hidden = false;
      var zone, label, message;
      if (atBed < threshold) {
        zone = 'clear';
        label = section.dataset.clearLabel;
        message = section.dataset.clearMessage;
      } else if (atBed < thresholdHigh) {
        zone = 'over';
        label = section.dataset.overLabel;
        message = section.dataset.overMessage;
      } else {
        zone = 'high';
        label = section.dataset.highLabel;
        message = section.dataset.highMessage;
      }
      section.setAttribute('data-zone', zone);
      pill.textContent = label || '';
      verdictText.textContent = message || '';
    }

    var peak = 0;
    for (var t = 0; t <= AXIS_HOURS; t += 0.25) {
      var v = totalAt(drinks, t, HALF_LIFE_SLOW);
      if (v > peak) peak = v;
    }

    buildChart(chartEl, drinks, bedAxis, peak,
      'Caffeine level through the day, peaking at ' + Math.round(peak)
      + ' milligrams and falling to about ' + rounded + ' milligrams at bedtime. Sleep is affected above '
      + threshold + ' milligrams.', threshold);
  }

  function buildRow(section, presetId, time) {
    var sid = section.id;
    var row = document.createElement('div');
    row.className = 'nm-drink';
    row.setAttribute('data-drink-row', '');

    var uid = 'nm-d-' + Math.random().toString(36).slice(2, 8);
    var preset = PRESETS.filter(function (p) { return p.id === presetId; })[0] || PRESETS[0];

    // Drink type
    var f1 = document.createElement('div');
    f1.className = 'nm-field';
    var l1 = document.createElement('label');
    l1.className = 'nm-label';
    l1.setAttribute('for', uid + '-type');
    l1.textContent = 'Drink';
    var sel = document.createElement('select');
    sel.className = 'nm-select';
    sel.id = uid + '-type';
    sel.setAttribute('data-drink-type', '');
    PRESETS.forEach(function (p) {
      var o = document.createElement('option');
      o.value = p.id;
      o.textContent = p.label;
      if (p.id === preset.id) o.selected = true;
      sel.appendChild(o);
    });
    f1.appendChild(l1);
    f1.appendChild(sel);

    // Time
    var f2 = document.createElement('div');
    f2.className = 'nm-field';
    var l2 = document.createElement('label');
    l2.className = 'nm-label';
    l2.setAttribute('for', uid + '-time');
    l2.textContent = 'Time';
    var ti = document.createElement('input');
    ti.type = 'time';
    ti.className = 'nm-input';
    ti.id = uid + '-time';
    ti.value = time;
    ti.setAttribute('data-drink-time', '');
    f2.appendChild(l2);
    f2.appendChild(ti);

    // Milligrams
    var f3 = document.createElement('div');
    f3.className = 'nm-field';
    var l3 = document.createElement('label');
    l3.className = 'nm-label';
    l3.setAttribute('for', uid + '-mg');
    l3.textContent = 'Caffeine (mg)';
    var mi = document.createElement('input');
    mi.type = 'number';
    mi.className = 'nm-input';
    mi.id = uid + '-mg';
    mi.min = '0';
    mi.step = '5';
    mi.value = String(preset.mg);
    mi.setAttribute('data-drink-mg', '');
    f3.appendChild(l3);
    f3.appendChild(mi);

    // Remove
    var rm = document.createElement('button');
    rm.type = 'button';
    rm.className = 'nm-remove';
    rm.setAttribute('data-remove-drink', '');
    rm.textContent = 'Remove';

    row.appendChild(f1);
    row.appendChild(f2);
    row.appendChild(f3);
    row.appendChild(rm);

    sel.addEventListener('change', function () {
      var p = PRESETS.filter(function (x) { return x.id === sel.value; })[0];
      if (p) mi.value = String(p.mg);
      update(section);
    });
    [ti, mi].forEach(function (el) {
      el.addEventListener('input', function () { update(section); });
      el.addEventListener('change', function () { update(section); });
    });
    rm.addEventListener('click', function () {
      var rows = section.querySelectorAll('[data-drink-row]');
      if (rows.length <= 1) return;
      row.remove();
      syncRemoveButtons(section);
      update(section);
    });

    return row;
  }

  // A single remaining row has nothing meaningful to remove.
  function syncRemoveButtons(section) {
    var rows = section.querySelectorAll('[data-drink-row]');
    for (var i = 0; i < rows.length; i++) {
      var btn = rows[i].querySelector('[data-remove-drink]');
      if (btn) btn.style.visibility = rows.length <= 1 ? 'hidden' : 'visible';
    }
  }

  function init(section) {
    if (section.dataset.nmInit === '1') return;
    section.dataset.nmInit = '1';

    var list = section.querySelector('[data-drinks]');
    var addBtn = section.querySelector('[data-add-drink]');
    if (!list || !addBtn) return;

    list.appendChild(buildRow(section, 'drip', '08:00'));
    list.appendChild(buildRow(section, 'drip', '15:00'));
    syncRemoveButtons(section);

    addBtn.addEventListener('click', function () {
      list.appendChild(buildRow(section, 'drip', '17:00'));
      syncRemoveButtons(section);
      update(section);
    });

    section.querySelector('[data-bedtime]').addEventListener('input', function () { update(section); });
    section.querySelector('[data-bedtime]').addEventListener('change', function () { update(section); });

    update(section);
  }

  function boot(root) {
    var nodes = (root || document).querySelectorAll('section[id^="nm-caffeine-calculator-"]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nm-epdp-buybox"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.addEventListener('click', function(e) {
    const thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    const section = thumb.closest('section[id^="nm-epdp-buybox-"]');
    if (!section) return;
    const main = section.querySelector('[data-main-img]');
    if (main) {
      main.src = thumb.dataset.full;
      main.alt = thumb.dataset.alt || '';
      main.removeAttribute('srcset');
    }
    section.querySelectorAll('[data-thumb]').forEach(function(t) {
      t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nm-lp-bundle-cards"] && !Shopify.designMode) return;
  try {
    
(function() {
  // Backing out of checkout restores this page from the back/forward cache
  // with the tier buttons still disabled mid-"loading". Reload once in
  // exactly that case so the cards (and the cart badge) reflect reality.
  window.addEventListener('pageshow', function(e) {
    if (e.persisted && document.querySelector('.nm-lp-bundle-cards .nm-tier.is-loading, .nm-lp-bundle-cards .nm-rows-buy.is-loading')) {
      window.location.reload();
    }
  });

  document.addEventListener('click', async function(e) {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;

    const section = btn.closest('section[id^="nm-lp-bundle-cards-"]');
    if (!section) return;

    const variantId = section.dataset.variantId;
    const redirect = section.dataset.redirect || 'checkout';
    // Rows layout: one buy button, quantity comes from the checked row
    let quantity = parseInt(btn.dataset.quantity, 10);
    if (btn.hasAttribute('data-qty-from-rows')) {
      const picked = section.querySelector('.nm-row-input:checked');
      if (picked) quantity = parseInt(picked.value, 10);
    }
    const errorEl = section.querySelector('[data-error]');

    if (!variantId) {
      if (errorEl) {
        errorEl.textContent = 'No product configured. Set the product in the section editor.';
        errorEl.classList.add('is-visible');
      }
      return;
    }

    if (!quantity || quantity < 1) return;

    // Disable all tier buttons in this section while we process
    const allButtons = section.querySelectorAll('[data-add-to-cart]');
    allButtons.forEach(b => b.disabled = true);
    btn.classList.add('is-loading');

    if (errorEl) {
      errorEl.classList.remove('is-visible');
      errorEl.textContent = '';
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId, 10), quantity: quantity }]
        })
      });

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || 'Could not add to cart.');
      }

      // Success — handle redirect
      if (redirect === 'checkout') {
        window.location.href = '/checkout';
      } else if (redirect === 'cart') {
        window.location.href = '/cart';
      } else {
        // Try to open Horizon's cart drawer if present, otherwise refresh
        const cartDrawerOpen = document.querySelector('[data-cart-drawer-open], cart-drawer button');
        if (cartDrawerOpen) {
          cartDrawerOpen.click();
        }
        // Re-enable buttons since we stayed on page
        allButtons.forEach(b => b.disabled = false);
        btn.classList.remove('is-loading');
        // Trigger a cart update event for any listeners
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }
    } catch (err) {
      console.error('NM LP bundle add to cart error:', err);
      if (errorEl) {
        errorEl.textContent = err.message || 'Could not add to cart. Please try again.';
        errorEl.classList.add('is-visible');
      }
      allButtons.forEach(b => b.disabled = false);
      btn.classList.remove('is-loading');
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nm-lp-caffeine-math"] && !Shopify.designMode) return;
  try {
    
(function() {
  function parseTime(value) {
    if (!value) return null;
    const parts = value.split(':');
    if (parts.length !== 2) return null;
    const hours = parseInt(parts[0], 10);
    const minutes = parseInt(parts[1], 10);
    if (isNaN(hours) || isNaN(minutes)) return null;
    return hours + (minutes / 60);
  }

  function formatGap(hours) {
    if (hours === null || isNaN(hours)) return '—';
    const rounded = Math.round(hours * 10) / 10;
    return rounded + 'h';
  }

  function computeGap(caffeineTime, bedtime) {
    const caf = parseTime(caffeineTime);
    const bed = parseTime(bedtime);
    if (caf === null || bed === null) return null;
    let gap = bed - caf;
    if (gap < 0) gap += 24;
    return gap;
  }

  function updateSection(section) {
    const caffeineInput = section.querySelector('[data-caffeine-time]');
    const bedtimeInput = section.querySelector('[data-bedtime]');
    if (!caffeineInput || !bedtimeInput) return;

    const gap = computeGap(caffeineInput.value, bedtimeInput.value);

    const redThreshold = parseFloat(section.dataset.redThreshold) || 3;
    const orangeThreshold = parseFloat(section.dataset.orangeThreshold) || 10;

    const displayGap = section.querySelector('[data-display-gap]');
    const zonePill = section.querySelector('[data-zone-pill]');
    const zoneMessage = section.querySelector('[data-zone-message]');
    const bedtimeMarker = section.querySelector('[data-bedtime-marker]');
    const timelineWrap = section.querySelector('[data-max-hours]');
    const maxHours = timelineWrap ? parseFloat(timelineWrap.dataset.maxHours) || 16 : 16;

    if (displayGap) displayGap.textContent = formatGap(gap);

    if (bedtimeMarker && gap !== null) {
      const cappedGap = Math.min(gap, maxHours);
      const pos = (cappedGap / maxHours) * 100;
      bedtimeMarker.style.left = pos + '%';
    }

    if (gap === null) {
      section.removeAttribute('data-zone');
      if (zonePill) zonePill.textContent = '—';
      if (zoneMessage) zoneMessage.textContent = 'Enter your times above to see your caffeine math.';
      return;
    }

    let zone, label, message;
    if (gap < redThreshold) {
      zone = 'red';
      label = section.dataset.redLabel || 'Direct sleep disruption';
      message = section.dataset.redMessage || '';
    } else if (gap < orangeThreshold) {
      zone = 'orange';
      label = section.dataset.orangeLabel || 'Still in the disruption window';
      message = section.dataset.orangeMessage || '';
    } else {
      zone = 'green';
      label = section.dataset.greenLabel || 'Clear for sleep';
      message = section.dataset.greenMessage || '';
    }

    section.setAttribute('data-zone', zone);
    if (zonePill) zonePill.textContent = label;
    if (zoneMessage) zoneMessage.textContent = message;
  }

  function init(section) {
    const caffeineInput = section.querySelector('[data-caffeine-time]');
    const bedtimeInput = section.querySelector('[data-bedtime]');
    if (!caffeineInput || !bedtimeInput) return;

    caffeineInput.addEventListener('input', function() { updateSection(section); });
    bedtimeInput.addEventListener('input', function() { updateSection(section); });
    caffeineInput.addEventListener('change', function() { updateSection(section); });
    bedtimeInput.addEventListener('change', function() { updateSection(section); });

    updateSection(section);
  }

  document.querySelectorAll('section[id^="nm-lp-caffeine-math-"]').forEach(init);

  document.addEventListener('shopify:section:load', function(event) {
    const section = event.target.querySelector('section[id^="nm-lp-caffeine-math-"]');
    if (section) init(section);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nm-three-block-feature"] && !Shopify.designMode) return;
  try {
    
(function() {
  // Bind once, works in storefront + theme editor preview
  document.addEventListener('click', function(e) {
    const trigger = e.target.closest('[data-label-trigger]');
    const closeEl = e.target.closest('[data-label-close]');

    // OPEN
    if (trigger) {
      const section = trigger.closest('section[id^="nm-three-block-feature-"]');
      if (!section) return;

      const modal = section.querySelector('[data-label-modal]');
      if (!modal) return;

      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('nm-lock-scroll');
      return;
    }

    // CLOSE
    if (closeEl) {
      const section = closeEl.closest('section[id^="nm-three-block-feature-"]');
      if (!section) return;

      const modal = section.querySelector('[data-label-modal]');
      if (!modal) return;

      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('nm-lock-scroll');
      return;
    }
  });

  // ESC to close (delegated)
  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;

    document.querySelectorAll('section[id^="nm-three-block-feature-"] [data-label-modal].is-open')
      .forEach(modal => {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('nm-lock-scroll');
      });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
